import { Box, Icon, IconButton } from '@chakra-ui/react'
import React, { useEffect } from 'react'
import Navbar from '../../components/core/Navbar'
import { LuMoon, LuSun } from 'react-icons/lu'
import { useColorMode } from '../../components/ui/color-mode'
import LandingServices from './voting/LandingServices'
import InfoSection from './voting/InfoSection'
import Advantages from './voting/Advantages'
import OurCover from './voting/OurCover'
import OurPricing from './voting/OurPricing'
import Footer from '../Home/Components/Footer'
import DashboradViewSection from './voting/DashboradViewSection'
import ScrollToTopButton from '../../components/core/ScrollToTopButton'
import { SectionWrapper } from '../Home/Home'


const ServicesGlobal = () => {

  const { colorMode, toggleColorMode } = useColorMode()
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])
  

  
  return (
    <Box>
      <Navbar globalColor='green'/>
      <SectionWrapper disable3D>
        <LandingServices />
      </SectionWrapper>
      <InfoSection/>
      <Advantages/>
      <DashboradViewSection/>
      <OurCover/>
      <OurPricing/>
      

      <Footer footerImage={require('../../assets/Online/4.png')}/>

      {/* floatting button */}
        <IconButton position={'fixed'} bottom={4} right={4} shadow={'xl'} zIndex={1000} onClick={toggleColorMode} variant={'solid'} rounded={'full'}>
          <Icon boxSize={4}>
            {colorMode === 'light' ? <LuMoon /> : <LuSun />}
          </Icon>
        </IconButton>
      <ScrollToTopButton />
    </Box>
  )
}

export default ServicesGlobal